import { useState, useEffect } from "react";
import {
  Tooltip,
  Typography,
  Box,
  IconButton,
  InputBase,
  Divider,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseProductGifts } from "./UseProductGifts";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../../components/CustomPagination";
import ProgressCom from "../../../components/ProgressCom";
import Detail from "../../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import AddProductGift from "./AddProductGift";
import ProductGiftChange from "./ProductGiftChange";
import { UseMyPC } from "../../../hooks/UseMyPC";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteRow from "../../../components/DeleteRow";
import { deCapitalizeFirstLetter } from "../../../util/Utils";

export default function ProductGiftsList() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { getProductgiftsList, deleteProductgifts } = UseProductGifts();

  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("giftID");
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [productRes, setProductRes] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getProductgiftsList(
      myPc,
      search,
      (products) => {
        setProductRes(products);
      },
      true
    );
  }, [myPc]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }
  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "productID",
      width: 100,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
    },
    {
      field: "productName",
      headerName: "محصول",
      width: 260,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "giftID",
      headerName: "کد هدیه",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "giftName",
      headerName: "هدیه",
      width: 260,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.giftName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 70,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    productID: cellValues.row.productID,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/productgifts" }],
      }}
    >
      <Box sx={{ height: "30rem", mb: 3 }}>
        {productRes ? (
          <DataGrid
            className="ltr-grid"
            disableVirtualization
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={productRes.pageCondition.pageCount}
            paginationMode="server"
            page={productRes.pageCondition.page - 1}
            rows={productRes.products}
            Pagination
            onPageChange={(page) => {
              updatePage(page + 1);
            }}
            rowCount={
              productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : 1
            }
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                isLtr: true,
                nofab: true,
                rowCount: productRes?.pageCondition.totalItemCount
                  ? productRes.pageCondition.totalItemCount
                  : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: deCapitalizeFirstLetter(myPc.sortColumn),
                    sort: deCapitalizeFirstLetter(myPc.sortOrder),
                  },
                ],
              },
              pagination: {
                page: myPc.page,
              },
            }}
            onSortModelChange={(model) => {
              updateSort(
                model[0].field,
                model[0].sort == "asc" ? "asc" : "desc"
              );
            }}
            sortingOrder={["desc", "asc"]}
            sortingMode="server"
          />
        ) : (
          <ProgressCom></ProgressCom>
        )}
      </Box>
      <AddProductGift
        callback={() => {
          setProgress(true);
          refresh();
        }}
      />
      <ProductGiftChange
        callback={() => {
          setProgress(true);
          refresh();
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"هدیه محصول"}
        callback={() => {
          setProgress(true);
          let model = {
            productID: deleteState.productID,
          };
          deleteProductgifts(model, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
